/**
 * ============================================================================
 * useStartRequalMutation — Phase 6e frontend (Equipment & Validation).
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: POST /api/v1/equipment/requalifications/{id}/start — a validation
 *          lead picks up a PENDING requalification task. The server records
 *          the lead and stamps started_at_utc.
 * ============================================================================
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiFetch, newIdempotencyKey } from '../../api/client';
import type { RequalScheduleRow } from './useRequalificationScheduleQuery';

export interface StartRequalInput {
  requalificationId: string;
  validation_lead: string;
  signature_bundle_id: string;
}

export function useStartRequalMutation(): UseMutationResult<
  RequalScheduleRow,
  Error,
  StartRequalInput
> {
  return useMutation<RequalScheduleRow, Error, StartRequalInput>({
    mutationFn: ({ requalificationId, ...body }) =>
      apiFetch<RequalScheduleRow>(
        `/api/v1/equipment/requalifications/${encodeURIComponent(requalificationId)}/start`,
        {
          method: 'POST',
          body,
          idempotencyKey: newIdempotencyKey(),
        },
      ),
  });
}
